import styled from "styled-components";

export const DocumentationTrigger = styled.button.attrs({ type: "button" })`
    cursor: pointer;
    padding: 0;
    background: none;
    border: none;
    line-height: 1;
    color: ${({ theme }) => theme.color.grayDairyDarker};

    &:hover {
        color: ${({ theme }) => theme.color.textGray};
    }
`;
